/**
 * ATTENTION! This file is auto-generated for the 'accounting' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { AccountingCurrencyRepository } from '../server/repositories/AccountingCurrencyRepository';
import type { AccountingTaxRepository } from '../server/repositories/AccountingTaxRepository';
import type { AccountingMeasureRepository } from '../server/repositories/AccountingMeasureRepository';
import type { AccountingLegalEntityRepository } from '../server/repositories/AccountingLegalEntityRepository';
import type { AccountingLegalEntityBankAccountRepository } from '../server/repositories/AccountingLegalEntityBankAccountRepository';
import type { AccountingDocumentTypeRepository } from '../server/repositories/AccountingDocumentTypeRepository';
import type { AccountingAllocationTypeRepository } from '../server/repositories/AccountingAllocationTypeRepository';
import type { AccountingDocumentRepository } from '../server/repositories/AccountingDocumentRepository';
import type { AccountingDocumentLineRepository } from '../server/repositories/AccountingDocumentLineRepository';
import type { AccountingDocumentTransactionRepository } from '../server/repositories/AccountingDocumentTransactionRepository';
import type { AccountingContractRepository } from '../server/repositories/AccountingContractRepository';
import type { SupplierDocRepository } from '../server/repositories/SupplierDocRepository';
import type { OrderDocRepository } from '../server/repositories/OrderDocRepository';
import type { PayDocRepository } from '../server/repositories/PayDocRepository';
import type { SellDocRepository } from '../server/repositories/SellDocRepository';
import type { InvoiceDocRepository } from '../server/repositories/InvoiceDocRepository';
import type { InvoiceDocLineRepository } from '../server/repositories/InvoiceDocLineRepository';
import type { DocTypeAttributeRepository } from '../server/repositories/DocTypeAttributeRepository';
import type { DocTypeAttributeOptionRepository } from '../server/repositories/DocTypeAttributeOptionRepository';
import type { DocAttributeValueRepository } from '../server/repositories/DocAttributeValueRepository';
import type { AccountingWarehouseRepository } from '../server/repositories/AccountingWarehouseRepository';
import type { StockEntryRepository } from '../server/repositories/StockEntryRepository';
import type { AccountingDocumentStatusRepository } from '../server/repositories/AccountingDocumentStatusRepository';
import type { AccountingDocumentEventRepository } from '../server/repositories/AccountingDocumentEventRepository';
import type { AccountingDocumentReferenceTypeRepository } from '../server/repositories/AccountingDocumentReferenceTypeRepository';
import type { AccountingDocumentReferenceRepository } from '../server/repositories/AccountingDocumentReferenceRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","aggregateBy","countGroups","meta","getInstance","columns","filters"];

type AccountingCurrencyRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingCurrencyRepository>;
export function useAccountingCurrencyRepository(): AccountingCurrencyRepositoryClient { return makeRepositoryProxy<AccountingCurrencyRepositoryClient>('accounting::AccountingCurrencyRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingCurrencyRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingCurrencyRepository = useAccountingCurrencyRepository();

type AccountingTaxRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingTaxRepository>;
export function useAccountingTaxRepository(): AccountingTaxRepositoryClient { return makeRepositoryProxy<AccountingTaxRepositoryClient>('accounting::AccountingTaxRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingTaxRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingTaxRepository = useAccountingTaxRepository();

type AccountingMeasureRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingMeasureRepository>;
export function useAccountingMeasureRepository(): AccountingMeasureRepositoryClient { return makeRepositoryProxy<AccountingMeasureRepositoryClient>('accounting::AccountingMeasureRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingMeasureRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingMeasureRepository = useAccountingMeasureRepository();

type AccountingLegalEntityRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingLegalEntityRepository>;
export function useAccountingLegalEntityRepository(): AccountingLegalEntityRepositoryClient { return makeRepositoryProxy<AccountingLegalEntityRepositoryClient>('accounting::AccountingLegalEntityRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingLegalEntityRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingLegalEntityRepository = useAccountingLegalEntityRepository();

type AccountingLegalEntityBankAccountRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingLegalEntityBankAccountRepository>;
export function useAccountingLegalEntityBankAccountRepository(): AccountingLegalEntityBankAccountRepositoryClient { return makeRepositoryProxy<AccountingLegalEntityBankAccountRepositoryClient>('accounting::AccountingLegalEntityBankAccountRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingLegalEntityBankAccountRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingLegalEntityBankAccountRepository = useAccountingLegalEntityBankAccountRepository();

type AccountingDocumentTypeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingDocumentTypeRepository>;
export function useAccountingDocumentTypeRepository(): AccountingDocumentTypeRepositoryClient { return makeRepositoryProxy<AccountingDocumentTypeRepositoryClient>('accounting::AccountingDocumentTypeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingDocumentTypeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingDocumentTypeRepository = useAccountingDocumentTypeRepository();

type AccountingAllocationTypeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingAllocationTypeRepository>;
export function useAccountingAllocationTypeRepository(): AccountingAllocationTypeRepositoryClient { return makeRepositoryProxy<AccountingAllocationTypeRepositoryClient>('accounting::AccountingAllocationTypeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingAllocationTypeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingAllocationTypeRepository = useAccountingAllocationTypeRepository();

type AccountingDocumentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingDocumentRepository>;
export function useAccountingDocumentRepository(): AccountingDocumentRepositoryClient { return makeRepositoryProxy<AccountingDocumentRepositoryClient>('accounting::AccountingDocumentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingDocumentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingDocumentRepository = useAccountingDocumentRepository();

type AccountingDocumentLineRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingDocumentLineRepository>;
export function useAccountingDocumentLineRepository(): AccountingDocumentLineRepositoryClient { return makeRepositoryProxy<AccountingDocumentLineRepositoryClient>('accounting::AccountingDocumentLineRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingDocumentLineRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingDocumentLineRepository = useAccountingDocumentLineRepository();

type AccountingDocumentTransactionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingDocumentTransactionRepository>;
export function useAccountingDocumentTransactionRepository(): AccountingDocumentTransactionRepositoryClient { return makeRepositoryProxy<AccountingDocumentTransactionRepositoryClient>('accounting::AccountingDocumentTransactionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingDocumentTransactionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingDocumentTransactionRepository = useAccountingDocumentTransactionRepository();

type AccountingContractRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingContractRepository>;
export function useAccountingContractRepository(): AccountingContractRepositoryClient { return makeRepositoryProxy<AccountingContractRepositoryClient>('accounting::AccountingContractRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingContractRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingContractRepository = useAccountingContractRepository();

type SupplierDocRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<SupplierDocRepository>;
export function useSupplierDocRepository(): SupplierDocRepositoryClient { return makeRepositoryProxy<SupplierDocRepositoryClient>('accounting::SupplierDocRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useSupplierDocRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const supplierDocRepository = useSupplierDocRepository();

type OrderDocRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<OrderDocRepository>;
export function useOrderDocRepository(): OrderDocRepositoryClient { return makeRepositoryProxy<OrderDocRepositoryClient>('accounting::OrderDocRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useOrderDocRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const orderDocRepository = useOrderDocRepository();

type PayDocRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PayDocRepository>;
export function usePayDocRepository(): PayDocRepositoryClient { return makeRepositoryProxy<PayDocRepositoryClient>('accounting::PayDocRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePayDocRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const payDocRepository = usePayDocRepository();

type SellDocRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<SellDocRepository>;
export function useSellDocRepository(): SellDocRepositoryClient { return makeRepositoryProxy<SellDocRepositoryClient>('accounting::SellDocRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useSellDocRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const sellDocRepository = useSellDocRepository();

type InvoiceDocRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InvoiceDocRepository>;
export function useInvoiceDocRepository(): InvoiceDocRepositoryClient { return makeRepositoryProxy<InvoiceDocRepositoryClient>('accounting::InvoiceDocRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInvoiceDocRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const invoiceDocRepository = useInvoiceDocRepository();

type InvoiceDocLineRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InvoiceDocLineRepository>;
export function useInvoiceDocLineRepository(): InvoiceDocLineRepositoryClient { return makeRepositoryProxy<InvoiceDocLineRepositoryClient>('accounting::InvoiceDocLineRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInvoiceDocLineRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const invoiceDocLineRepository = useInvoiceDocLineRepository();

type DocTypeAttributeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DocTypeAttributeRepository>;
export function useDocTypeAttributeRepository(): DocTypeAttributeRepositoryClient { return makeRepositoryProxy<DocTypeAttributeRepositoryClient>('accounting::DocTypeAttributeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDocTypeAttributeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const docTypeAttributeRepository = useDocTypeAttributeRepository();

type DocTypeAttributeOptionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DocTypeAttributeOptionRepository>;
export function useDocTypeAttributeOptionRepository(): DocTypeAttributeOptionRepositoryClient { return makeRepositoryProxy<DocTypeAttributeOptionRepositoryClient>('accounting::DocTypeAttributeOptionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDocTypeAttributeOptionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const docTypeAttributeOptionRepository = useDocTypeAttributeOptionRepository();

type DocAttributeValueRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DocAttributeValueRepository>;
export function useDocAttributeValueRepository(): DocAttributeValueRepositoryClient { return makeRepositoryProxy<DocAttributeValueRepositoryClient>('accounting::DocAttributeValueRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDocAttributeValueRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const docAttributeValueRepository = useDocAttributeValueRepository();

type AccountingWarehouseRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingWarehouseRepository>;
export function useAccountingWarehouseRepository(): AccountingWarehouseRepositoryClient { return makeRepositoryProxy<AccountingWarehouseRepositoryClient>('accounting::AccountingWarehouseRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingWarehouseRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingWarehouseRepository = useAccountingWarehouseRepository();

type StockEntryRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<StockEntryRepository>;
export function useStockEntryRepository(): StockEntryRepositoryClient { return makeRepositoryProxy<StockEntryRepositoryClient>('accounting::StockEntryRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useStockEntryRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const stockEntryRepository = useStockEntryRepository();

type AccountingDocumentStatusRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingDocumentStatusRepository>;
export function useAccountingDocumentStatusRepository(): AccountingDocumentStatusRepositoryClient { return makeRepositoryProxy<AccountingDocumentStatusRepositoryClient>('accounting::AccountingDocumentStatusRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingDocumentStatusRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingDocumentStatusRepository = useAccountingDocumentStatusRepository();

type AccountingDocumentEventRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingDocumentEventRepository>;
export function useAccountingDocumentEventRepository(): AccountingDocumentEventRepositoryClient { return makeRepositoryProxy<AccountingDocumentEventRepositoryClient>('accounting::AccountingDocumentEventRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingDocumentEventRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingDocumentEventRepository = useAccountingDocumentEventRepository();

type AccountingDocumentReferenceTypeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingDocumentReferenceTypeRepository>;
export function useAccountingDocumentReferenceTypeRepository(): AccountingDocumentReferenceTypeRepositoryClient { return makeRepositoryProxy<AccountingDocumentReferenceTypeRepositoryClient>('accounting::AccountingDocumentReferenceTypeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingDocumentReferenceTypeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingDocumentReferenceTypeRepository = useAccountingDocumentReferenceTypeRepository();

type AccountingDocumentReferenceRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccountingDocumentReferenceRepository>;
export function useAccountingDocumentReferenceRepository(): AccountingDocumentReferenceRepositoryClient { return makeRepositoryProxy<AccountingDocumentReferenceRepositoryClient>('accounting::AccountingDocumentReferenceRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccountingDocumentReferenceRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accountingDocumentReferenceRepository = useAccountingDocumentReferenceRepository();

type searchBankByBikType = typeof import('../server/functions/searchBankByBik').searchBankByBik;
export const searchBankByBik: RpcFunctionClient<searchBankByBikType> = makeFunctionProxy<searchBankByBikType>('accounting::searchBankByBik');

type suggestBankByBikType = typeof import('../server/functions/suggestBankByBik').suggestBankByBik;
export const suggestBankByBik: RpcFunctionClient<suggestBankByBikType> = makeFunctionProxy<suggestBankByBikType>('accounting::suggestBankByBik');
